import '../scss/main.scss'

gsap.registerPlugin(ScrollTrigger)

import { Accordion } from './commons/accordion.js'
import Modal from './commons/modal.js'
import HiddenMenu from './components/HiddenMenu.js'
import Tab from './components/Tab.js'
import Pointer from './commons/pointer.js'

import { win, setWin, setVh, setVw, isTouchDevice } from './utils/index.js'


const App = new function () {
	const body = document.body;

	this.init = () => {

		// Check if the page is still loading
		var preloader = document.querySelector('.preloader');
		if (document.readyState !== "complete" && document.querySelector('.preloader')) {
			console.log("Page is still loading...");
		} else {
			preloader.classList.add('hide');
			console.log("Page has finished loading.");
		}

		// Hide the preloader element when the page has finished loading
		// window.addEventListener("load", function() {
		// 	if (preloader) {
		// 	}
		// });

		// Initial setup
		setWin()
		setVh()
		setVw()
		
		// If is Touch Device
		if (isTouchDevice) document.body.classList.add('is-touch-device')
		window.addEventListener('resize', this.onResize)

		// Pointer
		Pointer.init();

		// Accordion //-- Must Be Before Inview Init --//
		Accordion.init();

		// Modal
		Modal.init()

		// Components
		HiddenMenu.init()
		// Tab.init()
  	}

	this.onResize = () => {
		setWin()
		setVh()
		setVw()
	}

}

window.addEventListener('load', App.init)